import React, { useState, useEffect } from "react";
import styles from "./style.module.scss";
import Cleave from "cleave.js/react";
import useDomainStore from "../../../stores/domain";

const TimeInput = ({
  label,
  onBlur,
  onChange,
  value,
  error = "",
  name,
  id,
}) => {
  const { isKurvDomain } = useDomainStore();
  const [dropOpen, setDropOpen] = useState(false);
  const [meridiem, setMeridiem] = useState("AM");
  const [time, setTime] = useState("");
  const onMeridiemChange = (value) => {
    setMeridiem(value);
    setDropOpen(false);
  };

  const handleChange = (e) => {
    let time = e.target.value;
    setTime(time);
  };

  const handleBlur = (e) => {
    if (onBlur) {
      onBlur({
        target: {
          name: name,
          value: value,
        },
      });
    }
  };

  useEffect(() => {
    if (value) {
      let [time, meridiem] = value.split(" ");
      setTime(time);
      setMeridiem(meridiem?.toUpperCase());
    }
  }, [value]);

  useEffect(() => {
    if (time && meridiem) {
      let formattedTime = `${time} ${meridiem}`;
      onChange(formattedTime);
    }
  }, [time, meridiem]);

  return (
    <div
      className={`${styles.timeInput} ${isKurvDomain ? styles.kurv_theme : ""}`}
    >
      <label className={styles.label} htmlFor={id}>
        {label}
      </label>
      <div className={styles.inputContainer}>
        <Cleave
          placeholder="00 : 00"
          options={{ time: true, timePattern: ["h", "m"] }}
          onChange={handleChange}
          onBlur={handleBlur}
          value={value}
          name={name}
          id={id}
          inputMode="numeric"
        />
        <div
          className={`${styles.timeDesignation} ${dropOpen ? styles.open : ""}`}
          onClick={() => setDropOpen(!dropOpen)}
        >
          {meridiem}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M7.29289 10.7071C7.68342 11.0976 8.31658 11.0976 8.70711 10.7071L11.7071 7.70711C12.0976 7.31658 12.0976 6.68342 11.7071 6.29289C11.3166 5.90237 10.6834 5.90237 10.2929 6.29289L8 8.58579L5.70711 6.29289C5.31658 5.90237 4.68342 5.90237 4.29289 6.29289C3.90237 6.68342 3.90237 7.31658 4.29289 7.70711L7.29289 10.7071Z"
              fill="#3A383F"
            />
          </svg>

          {dropOpen && (
            <div className={styles.dropContent}>
              <p onClick={() => onMeridiemChange("AM")}>AM</p>
              <p onClick={() => onMeridiemChange("PM")}>PM</p>
            </div>
          )}
        </div>
      </div>
      <span className={styles.timezone}>EST time zone</span>
      {error && <p className={styles.error}>{error}</p>}
    </div>
  );
};

export default TimeInput;
